import {FC, SVGProps} from 'react';

export const OrdersNavIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M4 3H12V5H4V3Z" fill="currentColor" />
		<path fillRule="evenodd" clipRule="evenodd" d="M20 5H4V14H20V5ZM16 10H6V12H16V10Z" fill="currentColor" />
		<path d="M12 18C13.1046 18 14 17.1046 14 16H22V22H2V16H10C10 17.1046 10.8954 18 12 18Z" fill="currentColor" />
	</svg>
);

export const OffersNavIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM7.17113 7.17159L14.9493 5.05029L12.828 12.8284L5.0498 14.9498L7.17113 7.17159ZM10.9998 10C10.9998 10.5523 10.5521 11 9.99978 11C9.44749 11 8.99978 10.5523 8.99978 10C8.99978 9.44776 9.44749 9.00004 9.99978 9.00004C10.5521 9.00004 10.9998 9.44776 10.9998 10Z"
			fill="currentColor"
		/>
	</svg>
);

export const WalletNavIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M16 2V0H0V2H16Z" fill="currentColor" />
		<path d="M2 4V2H0V4H2Z" fill="currentColor" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 4H20V18H0V4ZM16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z"
			fill="currentColor"
		/>
	</svg>
);

export const ProfileNavIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
			fill="currentColor"
		/>
		<path d="M4 20.5C4 16.9101 7.13401 14 11 14H13C16.866 14 20 16.9101 20 20.5V22H4V20.5Z" fill="currentColor" />
	</svg>
);
